import { FC } from 'react';

import { withA11yVisuallyHidden } from '@telialt/common-a11y/src/withA11yVisuallyHidden';

import { OldPriceTagElement } from './PriceTag.styles';

const OldPriceAccessible = withA11yVisuallyHidden(OldPriceTagElement);

type Props = { price: string; priceA11y: string; className?: string };
export const OldPriceTag: FC<Props> = ({ price, priceA11y, className }) => {
    if (!price) {
        return null;
    }

    return (
        <OldPriceAccessible accessible={priceA11y} className={className}>
            {price}
        </OldPriceAccessible>
    );
};
